<template>
  <b-container v-if="type && models" fluid>
    <page-title icon="fas fa-truck-moving">
      <translate v-if="id">Carrier Edit</translate>
      <translate v-else>New Carrier</translate>
      <template #extras>
        <b-button size="sm" variant="dark" v-b-modal.modalFetchExternalData class="p-1">
          <font-awesome-icon :icon="['far', 'eye']" />
          <translate>External</translate>
        </b-button>
      </template>
    </page-title>
    <b-modal ref="modalFetchExternalData" id="modalFetchExternalData" hide-header hide-footer @hide="externalData = {}">
      <b-form @submit.prevent.stop="fetchExternalData">
        <b-form-group>
          <label for="external-id" v-translate>Carrier External ID (exact)</label>
          <b-form-input type="text" id="external-id" v-model="externalDataId" />
        </b-form-group>
        <b-form-group>
          <b-button size="sm" type="submit" v-translate>Fetch Data</b-button>
        </b-form-group>

        <b-alert variant="warning" :show="!!externalErrorMessage" class="mt-3">
          <h4 class="mb-0" v-html="externalErrorMessage"></h4>
        </b-alert>

        <div v-if="Object.keys(this.externalData).length > 0">
          <div v-if="id">
            <b-table :items="externalDataItems" :fields="['field', 'local', 'remote']"></b-table>
            <hr>
            <b-button-group>
              <b-button size="sm" variant="success" @click="overwriteWithExternalData" class="p-1">
                <translate>Overwrite Current Data</translate>
              </b-button>
              <b-button size="sm" variant="danger" @click="$refs.modalFetchExternalData.hide()" class="p-1">
                <translate>Close and Dismiss</translate>
              </b-button>
            </b-button-group>
          </div>
          <div v-else>
            <b-table :items="externalDataItems" :fields="['field', 'remote']"></b-table>
            <hr>
            <b-button-group>
              <b-button size="sm" variant="success" @click="overwriteWithExternalData" class="p-1">
                <translate>Import External Data</translate>
              </b-button>
              <b-button size="sm" variant="danger" @click="$refs.modalFetchExternalData.hide()" class="p-1">
                <translate>Close and Dismiss</translate>
              </b-button>
            </b-button-group>
          </div>
        </div>
      </b-form>
    </b-modal>

    <b-row class="mb-3 text-center" v-if="ecosystem.product !== 'carriers' && id">
      <b-col>
        <b-button-group>
          <b-button size="sm" variant="success" @click="approveCompany" :disabled="item.status === 'confirmed' || item.status === 'rejected'" v-translate>
            CONFIRM Company
          </b-button>
          <b-button size="sm" variant="warning" @click="disableCompany" :disabled="item.status === 'pending' || item.status === 'rejected'" v-translate>
            DISABLE Company
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>

    <api-item-edit ref="argh" type="carriers" :static-item="Object.keys(staticItem.item).length > 0 ? staticItem : null" :model="models.carriers" :id="id" @item-loaded="itemLoaded" />

  </b-container>
</template>

<script>
import { CompanyService } from '@/services/api'
import ApiItemEdit from '@/components/ApiLists/ApiItemEdit'

export default {
  name: 'CarrierEdit',
  title() {
    if (this.id) {
      return this.$gettext('Carrier Edit')
    } else {
      return this.$gettext('New Carrier')
    }
  },
  components: {
    ApiItemEdit
  },
  props: {
    type: {
      type: String,
      default: 'carriers'
    },
    id: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      model: null,
      item: {},
      staticItem: {
        item: {}
      },
      externalDataId: 'RC3.',
      externalData: {},
      externalDataMap: {
        name: 'LOCATION_NAME',
        business_name: 'LOCATION_NAME',
        external_id: 'LOCATION_GID',
        address: ['ADDRESS_LINE', 'CITY', 'STATE_CODE', 'POSTAL_CODE', 'COUNTRY_CODE']
      },
      externalDataItems: [],
      externalErrorMessage: ''
    }
  },
  created () {
    this.model = this.models.carriers
  },
  methods: {
    itemLoaded(item) {
      this.externalDataId = item.external_id || this.externalDataId
      this.item = item

      if (!item.billing_details) {
        this.item = {
          ...this.item,
          billing_details: {
            name: 'faked',
            last_name: 'faked',
            phone: 'faked',
            emails: ['faked@faked.com']
          }
        }
        this.$refs.argh.item = {...this.$refs.argh.item, ...this.item}
      }
    },
    async fetchExternalData() {
      let dataExists = false
      this.externalData = {}
      this.externalErrorMessage = ''
      if (!this.id) {
        const params = {
          filter_groups: [{
            filters: [
              ['external_id', 'eq', this.externalDataId]
            ]
          }]
        }
        dataExists = await CompanyService.getAll({params})
          .then(response => {
            return response.body.data.length > 0 ? response.body.data[0] : false
          })
      }

      if (this.id || !dataExists) {
        // CompanyService.fetchExternalData({params: {id: this.externalDataId}})
        this.$http.get(this.$appConfig.api.baseUrl + 'platforms/g3/carriers', {params: {id: this.externalDataId}})
          .then(response => {
            if (response.body.data.length > 0) {
              this.externalData = response.body.data[0]
              if (this.id) {
                let externalDataItems = []
                for (let i = 0; i < Object.keys(this.externalDataMap).length; i++) {
                  const localKey = Object.keys(this.externalDataMap)[i]
                  const externalKey = Object.values(this.externalDataMap)[i]
                  let remoteData
                  if (Array.isArray(externalKey)) {
                    remoteData = []
                    for (const externalDataPart of externalKey) {
                      remoteData.push(this.externalData[externalDataPart])
                    }
                    remoteData = remoteData.filter(Boolean).join(', ')
                  } else {
                    remoteData = this.externalData[externalKey]
                  }
                  externalDataItems.push({
                    field: this.toTitleCase(localKey),
                    local: this.item[localKey],
                    remote: remoteData
                  })
                }
                this.externalDataItems = externalDataItems
              } else {
                let externalDataItems = []
                for (let i = 0; i < Object.keys(this.externalDataMap).length; i++) {
                  const localKey = Object.keys(this.externalDataMap)[i]
                  const externalKey = Object.values(this.externalDataMap)[i]
                  let remoteData
                  if (Array.isArray(externalKey)) {
                    remoteData = []
                    for (const externalDataPart of externalKey) {
                      remoteData.push(this.externalData[externalDataPart])
                    }
                    remoteData = remoteData.filter(Boolean).join(', ')
                  } else {
                    remoteData = this.externalData[externalKey]
                  }
                  externalDataItems.push({
                    field: this.toTitleCase(localKey),
                    remote: remoteData
                  })
                }
                this.externalDataItems = externalDataItems
              }
            } else {
              this.externalErrorMessage = this.$gettext('There are no results for this search. Please check the External ID.')
            }
          })
      } else {
        this.externalErrorMessage = `${this.$gettext('The Data you are trying to import ALREADY EXISTS.')}`
        this.externalErrorMessage += `<br><small><a href="${this.$router.resolve({name: 'CarriersEdit', params: {'id': dataExists.id}}).href}" target="_blank">${this.$gettext('Click to Edit Existing')}</a></small>`
      }
    },
    overwriteWithExternalData() {
      for (let i = 0; i < Object.keys(this.externalDataMap).length; i++) {
        const localKey = Object.keys(this.externalDataMap)[i]
        const externalKey = Object.values(this.externalDataMap)[i]
        let remoteData
        if (Array.isArray(externalKey)) {
          remoteData = []
          for (const externalDataPart of externalKey) {
            remoteData.push(this.externalData[externalDataPart])
          }
          remoteData = remoteData.filter(Boolean).join(', ')
        } else {
          remoteData = this.externalData[externalKey]
        }
        this.item[localKey] = remoteData
      }
      this.item = {...this.item, tin: 'tin_' + this.item.external_id, country_iso_code: this.profile?.company?.country_iso_code}
      this.$refs.argh.item = {...this.$refs.argh.item, ...this.item}
      this.$refs.modalFetchExternalData.hide()
    },
    approveCompany() {
      this.$refs.argh.patchItem()
      this.$nextTick(() => {
        CompanyService.enable(this.$route.params.id)
          .then(() => {
            this.$refs.argh.getItem()
          })
      })
    },
    disableCompany() {
      CompanyService.disable(this.$route.params.id)
        .then(() => {
          this.$refs.argh.getItem()
        })
    }
  }
}
</script>
